<template>
    <div>
    </div>
</template>

<script>
    import { mapActions, mapMutations, mapGetters } from 'vuex';

    export default {
        name: 'delete',
        data() {
            return {
                shop: {},
            }
        },
        created() {
            this.handleAction();
            this.GetShopById(this.$route.params.id)
                .then(shop => this.shop = shop)
                .catch(err => console.log(err))
        },
        methods: {
            ...mapActions([
                'confirmAction',
                'GetShopById',
                'DelShop',
                'DelShopFromUser',
                'GetAllShops'
            ]),
            handleAction() {
                this.confirmAction({
                    question: this.$t('COMPANYDATA.removeShop'),
                    data: this.shop,
                    callback: this.deleteShop
                })
            },
            async deleteShop () {
                if(this.shop.users) {
                    await this.$utils.resolvePromises(
                        this.shop.users.map(({id}) => 
                            this.DelShopFromUser({id, shopId: this.shop.id})
                    )).then(() => this.$router.go(-1))
                }
                await this.DelShop(this.shop)
                    .then(async () => {
                        await this.GetAllShops()
                            .then(() => this.$router.go(-1));
                    });
                
            },
        }
    }
</script>